import * as actionTypes from "../constants/AccountActionTypes";

const initialState = {
  details: {
    address: {}
  },
  tradedProducts: [],
  leadId: null,
};

const cartReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.SET_USER_ACCOUNT:
      let number;
      if (payload.details && payload.details.contactNumbers) {
        const found = payload.details.contactNumbers.find(({ isDefault }) => isDefault);
        if (found) number = found.number;
      }
      return { ...state, ...payload, details: { ...state.details, ...payload.details, number }};

    case actionTypes.SET_LEAD_ID:
      return { ...state, leadId: payload };
    
    case actionTypes.UPDATE_USER_ACCOUNT:
      const { field, value } = payload;
      const newState = { ...state };

      switch (field) {
        case 'firstName':
        case 'lastName':
        case 'number':
        case 'day':
        case 'month':
        case 'year':
          newState.details[field] = value;
          break;
        
        case 'country':
        case 'street':
        case 'suburb':
        case 'state':
        case 'postalCode':
          newState.details.address[field] = value;
          break;
        
        case 'email':
        case 'username':
        case 'password':
        case 'passwordConfirm':
        case 'hasTraded':
        case 'tradedProducts':
        case 'tradeFrequency':
        case 'broker':
        case 'hearAboutUs':
          newState[field] = value;
          break;
      
        default:
          break;
      }
      
      return { ...newState };
  
    default:
      return state;
  }
}

export default cartReducer;